// PAT-857: purely informational per-member tags, entirely separate from the
// 4-in-the-box leadership roles. "Project Manager" is a distinct tag from the
// existing "pm" leadership role ("Product Manager") — never abbreviate it as
// "PM" in copy or code.
export const MEMBER_TITLE_LABELS = {
  designer: 'Designer',
  projectManager: 'Project Manager',
  analyst: 'Analyst',
} as const;

export type MemberTitle = keyof typeof MEMBER_TITLE_LABELS;

export const MEMBER_TITLE_OPTIONS = Object.entries(MEMBER_TITLE_LABELS) as [
  MemberTitle,
  string,
][];

/**
 * Own-property check (not `in`/direct indexing) — a stored value like
 * "toString" or "__proto__" must not resolve to an inherited Object
 * prototype property.
 */
export function isMemberTitle(value: unknown): value is MemberTitle {
  return (
    typeof value === 'string' &&
    Object.prototype.hasOwnProperty.call(MEMBER_TITLE_LABELS, value)
  );
}
